import './WhyUs.css';
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next';

// Regjistro ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

function WhyUs() {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const { t } = useTranslation();

  useEffect(() => {
    const cards = cardsRef.current;
    
    // Vendos gjendjen fillestare të fshehur
    gsap.set(cards, {
      opacity: 0,
      y: 30,
      scale: 0.95
    });

    // Krijo timeline për animacionet
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 90%",
        end: "bottom 10%",
        toggleActions: "play none none reverse"
      }
    });

    // Shto animacionet për secilën kartë në timeline
    cards.forEach((card, index) => {
      tl.to(card, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.4,
        delay: index * 0.08,
        ease: "power2.out"
      }, index * 0.15); // Offset pak më i ngadaltë në timeline
    });

    // Pastro animacionet kur komponenti çmontohet
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section className="whyus-section" id="whyus" ref={sectionRef}>
      <div className="whyus-grid">
        <div 
          className="whyus-card" 
          ref={el => cardsRef.current[0] = el}
        >
          <h3>{t('whyus.card1')}</h3>
          <p>{t('whyus.desc1')}</p>
        </div>
        <div 
          className="whyus-card" 
          ref={el => cardsRef.current[1] = el}
        >
          <h3>{t('whyus.card2')}</h3>
          <p>{t('whyus.desc2')}</p>
        </div>
        <div 
          className="whyus-card" 
          ref={el => cardsRef.current[2] = el}
        >
          <h3>{t('whyus.card3')}</h3>
          <p>{t('whyus.desc3')}</p>
        </div>
      </div>
    </section>
  );
}

export default WhyUs; 